"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XhrHttpHandler = void 0;
var rxjs_1 = require("rxjs");
var HttpServiceResponse_1 = require("./HttpServiceResponse");
var operators_1 = require("rxjs/operators");
/**
 * @category HTTP
 */
var XhrHttpHandler = /** @class */ (function () {
    function XhrHttpHandler() {
    }
    XhrHttpHandler.prototype.handle = function (request, progressCallback) {
        var _this = this;
        return new rxjs_1.Observable(function (observer) {
            try {
                var req_1 = new XMLHttpRequest();
                _this.request = req_1;
                if (progressCallback) {
                    req_1.addEventListener('progress', function (e) {
                        if (e.lengthComputable) {
                            var percent = Math.round((e.loaded / e.total) * 100);
                            progressCallback(percent);
                        }
                    });
                }
                req_1.addEventListener('load', function () {
                    var response = createResponseFromXhr(request, req_1, request.options);
                    observer.next(response);
                });
                req_1.addEventListener('abort', function () {
                    var response = createResponseFromXhr(request, req_1, request.options);
                    observer.error({
                        request: req_1,
                        type: 'abort',
                        response: response,
                    });
                });
                req_1.addEventListener('error', function () {
                    var response = createResponseFromXhr(request, req_1, request.options);
                    // eslint-disable-next-line prefer-rest-params
                    observer.error({
                        request: req_1,
                        type: 'error',
                        response: response,
                    });
                });
                req_1.addEventListener('timeout', function () {
                    var response = createResponseFromXhr(request, req_1, request.options);
                    observer.error({
                        request: req_1,
                        type: 'timeout',
                        response: response,
                    });
                });
                req_1.open(request.options.method || 'GET', request.options.url);
                if (request.options.credentials === 'include') {
                    req_1.withCredentials = true;
                }
                else if (request.options.credentials === 'omit') {
                    req_1.withCredentials = false;
                }
                var omitContentTypeInHeaders_1 = false;
                if ((typeof globalThis.FormData !== 'undefined' &&
                    request.options.body instanceof globalThis.FormData) ||
                    (typeof globalThis.Blob !== 'undefined' && request.options.body instanceof globalThis.Blob)) {
                    omitContentTypeInHeaders_1 = true;
                }
                else if (typeof request.options.body === 'string') {
                    // Keep it
                }
                else {
                    request.options.body = JSON.stringify(request.options.body);
                }
                request.headers.forEach(function (value, key) {
                    if ((key || '').toLowerCase() === 'content-type' && omitContentTypeInHeaders_1) {
                        return;
                    }
                    req_1.setRequestHeader(key, value);
                });
                req_1.send(request.options.body);
            }
            catch (ex) {
                console.error('XhrHttpHandler error', ex);
                observer.error(ex);
            }
        }).pipe((0, operators_1.shareReplay)());
    };
    XhrHttpHandler.prototype.cancel = function () {
        var _a;
        (_a = this.request) === null || _a === void 0 ? void 0 : _a.abort();
    };
    return XhrHttpHandler;
}());
exports.XhrHttpHandler = XhrHttpHandler;
function createResponseFromXhr(httpRequest, req, options) {
    var headers = new Map();
    req.getAllResponseHeaders()
        .split('\r\n')
        .forEach(function (keyAndValue) {
        var _a = __read(keyAndValue.split(': '), 2), key = _a[0], value = _a[1];
        headers.set(key, value);
    });
    return new HttpServiceResponse_1.HttpServiceResponse(httpRequest, req.status, options.url, req.responseText, headers, options);
}
//# sourceMappingURL=XhrHttpHandler.js.map